import { render, staticRenderFns } from "./securitycode.vue?vue&type=template&id=044045e1&scoped=true&"
import script from "./securitycode.vue?vue&type=script&lang=js&"
export * from "./securitycode.vue?vue&type=script&lang=js&"
import style0 from "./securitycode.vue?vue&type=style&index=0&id=044045e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044045e1",
  null
  
)

export default component.exports